<template>
  <b-col md="12" xl="6">
    <section class="reservation">
      <p class="reservation__title">I dati della tua prenotazione</p>
      <div class="reservation__wrap">
        <div class="reservation__check">
          <span
            class="reservation__date"
            v-html="'Arrivo ' + '<strong class=\'semibold\'>' + reservation.arrival + '</strong>'"
          />
          <span class="reservation__time">{{ reservation.checkin }}</span>
        </div>
        <div class="reservation__check">
          <span
            class="reservation__date"
            v-html="'Partenza ' + '<strong class=\'semibold\'>' + reservation.departure + '</strong>'"
          />
          <span class="reservation__time">{{ reservation.checkout }}</span>
        </div>
      </div>
      <p
        class="reservation__duration"
        v-html="'Durata del soggiorno: <strong class=\'semibold\'>' + reservation.nights + '</strong>'"
      />
      <div class="reservation__info">
        <span class="reservation__info-text semibold">{{ reservation.rooms }}</span>
        <span class="reservation__info-text semibold ml-1">per {{ reservation.adults }}</span>
        <span class="reservation__info-text semibold ml-1" v-if="reservation.children">e {{ reservation.children }}</span>
      </div>
    </section>
  </b-col>
</template>

<script>
import {format_date_with_month} from '@bookingv3/utilities'
import moment from 'moment'

export default {
  inheritAttrs: false,
  name: 'reservation',

  components: {
  },

  props: {
    hotel: Object,
    solution: Object,
  },

  data() {
    return {
    }
  },

  computed: {

    // Genera la struttura dati della prenotazione
    reservation() {
      const {occupancy, accommodation} = this.solution,
            {checkin, checkout, products} = accommodation,
            {checkin_checkout_times} = this.hotel

      const times = Object.fromEntries(
        Object.entries(checkin_checkout_times).map(([key, value]) => {
          const time = value ? moment(value, "HH:mm:ss").format("HH:mm") : ''
          return [key, time]
        })
      )

      const {adults, children} = occupancy.reduce(
        (total, item) => {
          total.adults += item.adults
          total.children += item.children.length
          return total
        },
        { adults: 0, children: 0 }
      )

      const adults_label = adults > 1 ? 'adulti' : 'adulto',
            children_label = children > 1 ? 'bambini' : 'bambino'

      const nights = this.get_total_nights(checkin, checkout),
            nights_label = nights > 1 ? 'notti' : 'notte'

      const rooms = products.length,
            rooms_label = rooms > 1 ? 'camere' : 'camera'

      return {
        arrival: format_date_with_month(checkin),
        departure: format_date_with_month(checkout),
        checkin: this.get_formatted_timecheck(times.checkin_from, times.checkin_to),
        checkout: this.get_formatted_timecheck(times.checkout_from, times.checkout_to),
        nights: `${nights} ${nights_label}`,
        rooms: `${rooms} ${rooms_label}`,
        adults: `${adults} ${adults_label}`,
        children: children > 0 ? `${children} ${children_label}` : null,
      }

    }
  },

  created() {
  },

  mounted() {
  },

  methods: {

    // Calcolo totale delle notti
    get_total_nights(from_time, to_time) {
      const formatted_from = moment(from_time, 'YYYY-MM-DD')
      const formatted_to = moment(to_time, 'YYYY-MM-DD')
      return formatted_to.diff(formatted_from, 'days')
    },

    // Formattazione orari di checkin e checkout
    get_formatted_timecheck(...val){
      return val.filter(str => str).join(' - ')
    }
  },
}
</script>

<style lang="scss" scoped>

  .reservation {
    background-color: #fafcff;
    border-radius: 10px;
    padding: 15px 20px;
    border: 1px solid $gray-300;
    height: 100%;
    margin-top: $grid-gutter-width;

    @include media-breakpoint-up(xl){
      margin-top: 0;
    }

    &__title {
      font-size: $font-size-lg;
      font-weight: $vb-font-weight-semibold;
      margin-bottom: 10px;
    }

    &__wrap {
      display: flex;
      align-items: center;
    }

    &__check {
      span {
        display: block;
      }

      &:first-child {
        border-right: 1px solid $gray-300;
        margin-right: 20px;
        padding-right: 20px;
      }
    }

    &__duration {
      margin: 20px 0 5px;
    }

    &__info {
      display: flex;
      align-items: center;
    }
  }

</style>